// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc(100% - 40px);
  overflow: hidden;
  z-index: 1000;
  transition: width 500ms;
}

@media (max-width: 768px) {
  .sidebar.collapsed {
    width: 43px;
  }
}

@media (min-width: 768px) {
  .sidebar.collapsed {
    width: 45px;
  }
}

@media (min-width: 768px) {
  .sidebar.hidden {
    width: 0px;
  }
}

@media (max-width: 768px) {
  .sidebar.hidden {
    width: 0px;
  }
}

@media (min-width: 768px) {
  .sidebar {
    top: 6px;
    bottom: 6px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .sidebar {
    width: 305px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .sidebar {
    width: 390px;
  }
}
@media (min-width: 1200px) {
  .sidebar {
    width: 460px;
  }
}

.sidebar-left {
  left: 0;
}
@media (min-width: 768px) {
  .sidebar-left {
    left: 6px;
  }
}

.sidebar-right {
  right: 0;
}
@media (min-width: 768px) {
  .sidebar-right {
    right: 6px;
  }
}

.sidebar-tabs {
  /* top: 0; */
  /* bottom: 0; */
  /* height: 100%; */
  /* background-color: rgba(183, 200, 0, 0.9);  */
}
.sidebar-left .sidebar-tabs {
  /* left: 0;  */
}
.sidebar-right .sidebar-tabs {
  /* right: 0;  */
}
.sidebar-tabs,
.sidebar-tabs > ul {
  /* position: absolute; */
  /* width: 40px; */
  /* margin: 0; */
  /* padding: 0; */
  /* list-style-type: none;  */
}
.sidebar-tabs > li,
.sidebar-tabs > ul > li {
  /* width: 100%; */
  /* height: 40px; */
  /* color: #fff; */
  /* font-size: 12pt; */
  /* overflow: hidden; */
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.sidebar-tabs > li:hover,
.sidebar-tabs > ul > li:hover {
  /* color: #fff; */
  /* background-color: rgba(20, 116, 28, 0.7);  */
}
.sidebar-tabs > li.active,
.sidebar-tabs > ul > li.active {
  /* color: #fff; */
  /* background-color: rgba(20, 116, 28, 0.9);  */
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.sidebar-tabs > li.disabled,
.sidebar-tabs > ul > li.disabled {
  /* color: rgba(255, 255, 255, 0.4); */
}
.sidebar-tabs > li.disabled:hover,
.sidebar-tabs > ul > li.disabled:hover {
  /* background: transparent; */
}
.sidebar-tabs > li.disabled > a,
.sidebar-tabs > ul > li.disabled > a {
  /* cursor: default;  */
}
.sidebar-tabs > li > a,
.sidebar-tabs > ul > li > a {
  /* display: block; */
  /* width: 100%; */
  /* height: 100%; */
  /* line-height: 40px; */
  /* color: inherit; */
  /* text-decoration: none; */
  /* text-align: center;  */
}
.sidebar-tabs > ul + ul {
  bottom: 0;
}

.sidebar-content {
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  overflow-x: auto;
  overflow-y: auto;
}
.sidebar-left .sidebar-content {
  left: 40px;
  right: 0;
  top: 40px;
}
.sidebar-right .sidebar-content {
  left: 0;
  right: 40px;
  top: 40px;
}
.sidebar.collapsed > .sidebar-content {
  overflow-y: hidden;
}

.sidebar-pane {
  display: none;
  left: 0;
  right: 0;
  box-sizing: border-box;
}
.sidebar-pane.active {
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) and (max-width: 991px) {
  .sidebar-pane {
    min-width: 259px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .sidebar-pane {
    min-width: 344px;
  }
}
@media (min-width: 1200px) {
  .sidebar-pane {
    min-width: 399px;
  }
}

.sidebar-header {
  /* margin: -10px -20px 10px; */
  /* height: 40px; */
  /* padding: 0 20px; */
  /* line-height: 40px; */
  /* font-size: 14.4pt; */
  /* color: #fff; */
  /* background-color: rgba(183, 200, 0, 0.9);  */
}
.sidebar-right .sidebar-header {
  /* padding-left: 40px;  */
}

.sidebar-collapse {
  position: absolute;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
}
.sidebar-left .sidebar-collapse {
  right: 0px;
  top: 0px;
}
.sidebar-right .sidebar-collapse {
  left: 0px;
  top: 0px;
}

.sidebar-close {
  position: absolute;
  top: 0;
  right: 0; /* Anchor it to the right edge of the heading */
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar {
  background-color: rgba(255, 255, 255, 0.6);
}
@media (min-width: 768px) {
  .sidebar {
    border: 3px solid transparent;
    border-radius: 4px;
  }
}

@media (min-width: 768px) {
  .sidebar.hidden {
    border: 0px;
  }
}

.sidebar-left {
  border-right: 3px solid transparent;
}

.sidebar-right {
  border-left: 3px solid transparent;
}

.sidebar-tabs {
  overflow: hidden;
}
@media (min-width: 768px) {
  .sidebar-tabs {
    border-radius: 2px 0 0 2px;
  }
  .collapsed .sidebar-tabs {
    border-radius: 2px;
  }
}

@media (min-width: 768px) {
  .sidebar-content {
    border-radius: 0 2px 2px 0;
  }
}

.ol-viewport {
  background-color: #fff;
}

@media (min-width: 768px) {
  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-zoom,
  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-zoomslider,
  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-scale-line,
  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-sidebar-sticky {
    margin-left: 52px;
  }
}

@media (max-width: 768px) {
  .sidebar-map-control-open {
    margin-right: 46px;
  }

  .sidebar-map-control-collapsed {
    margin-right: 46px;
  }

  .sidebar-map-control-hidden {
    margin-right: 0;
  }
}


@media (min-width: 768px) and (max-width: 991px) {
   .sidebar-map-control-open {
    margin-right: 312px;
  }

  .sidebar-map-control-collapsed {
    margin-right: 46px;
  }

  .sidebar-map-control-hidden {
    margin-right: 0;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
   .sidebar-map-control-open {
    margin-right: 397px;
  }

  .sidebar-map-control-collapsed {
    margin-right: 46px;
  }

  .sidebar-map-control-hidden {
    margin-right: 0;
  }
}
@media (min-width: 1200px) {
   .sidebar-map-control-open {
    margin-right: 467px;
  }

  .sidebar-map-control-collapsed {
    margin-right: 46px;
  }

  .sidebar-map-control-hidden {
    margin-right: 0;
  }
}

.ol-rotate,
.ol-base-layer-switcher,
.ol-coord-zoom-status,
.ol-status-control {
  transition: margin-right 500ms, opacity .25s linear, visibility 0s linear !important;
}

.ol-swipe-tool {
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
}

.swipe-offset-large {
  bottom: 80px !important;
}

.swipe-offset-small {
  bottom: 48px !important;
}

.ol-overlaycontainer-stopevent {
  z-index: 5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Map/Controls/Sidebar/ol3-sidebar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,OAAO;AACT;AACA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,QAAQ;AACV;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB;qGACmG;AACrG;AACA;;EAEE,iBAAiB;EACjB,+CAA+C;AACjD;AACA;;EAEE,iBAAiB;EACjB,+CAA+C;EAC/C;qGACmG;AACrG;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,OAAO;EACP,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ,EAAE,+CAA+C;EACzD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;;IAIE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;GACG;IACC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;GACG;IACC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;GACG;IACC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;;EAIE,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".sidebar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: calc(100% - 40px);\n  overflow: hidden;\n  z-index: 1000;\n  transition: width 500ms;\n}\n\n@media (max-width: 768px) {\n  .sidebar.collapsed {\n    width: 43px;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar.collapsed {\n    width: 45px;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar.hidden {\n    width: 0px;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar.hidden {\n    width: 0px;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar {\n    top: 6px;\n    bottom: 6px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .sidebar {\n    width: 305px;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .sidebar {\n    width: 390px;\n  }\n}\n@media (min-width: 1200px) {\n  .sidebar {\n    width: 460px;\n  }\n}\n\n.sidebar-left {\n  left: 0;\n}\n@media (min-width: 768px) {\n  .sidebar-left {\n    left: 6px;\n  }\n}\n\n.sidebar-right {\n  right: 0;\n}\n@media (min-width: 768px) {\n  .sidebar-right {\n    right: 6px;\n  }\n}\n\n.sidebar-tabs {\n  /* top: 0; */\n  /* bottom: 0; */\n  /* height: 100%; */\n  /* background-color: rgba(183, 200, 0, 0.9);  */\n}\n.sidebar-left .sidebar-tabs {\n  /* left: 0;  */\n}\n.sidebar-right .sidebar-tabs {\n  /* right: 0;  */\n}\n.sidebar-tabs,\n.sidebar-tabs > ul {\n  /* position: absolute; */\n  /* width: 40px; */\n  /* margin: 0; */\n  /* padding: 0; */\n  /* list-style-type: none;  */\n}\n.sidebar-tabs > li,\n.sidebar-tabs > ul > li {\n  /* width: 100%; */\n  /* height: 40px; */\n  /* color: #fff; */\n  /* font-size: 12pt; */\n  /* overflow: hidden; */\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.sidebar-tabs > li:hover,\n.sidebar-tabs > ul > li:hover {\n  /* color: #fff; */\n  /* background-color: rgba(20, 116, 28, 0.7);  */\n}\n.sidebar-tabs > li.active,\n.sidebar-tabs > ul > li.active {\n  /* color: #fff; */\n  /* background-color: rgba(20, 116, 28, 0.9);  */\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.sidebar-tabs > li.disabled,\n.sidebar-tabs > ul > li.disabled {\n  /* color: rgba(255, 255, 255, 0.4); */\n}\n.sidebar-tabs > li.disabled:hover,\n.sidebar-tabs > ul > li.disabled:hover {\n  /* background: transparent; */\n}\n.sidebar-tabs > li.disabled > a,\n.sidebar-tabs > ul > li.disabled > a {\n  /* cursor: default;  */\n}\n.sidebar-tabs > li > a,\n.sidebar-tabs > ul > li > a {\n  /* display: block; */\n  /* width: 100%; */\n  /* height: 100%; */\n  /* line-height: 40px; */\n  /* color: inherit; */\n  /* text-decoration: none; */\n  /* text-align: center;  */\n}\n.sidebar-tabs > ul + ul {\n  bottom: 0;\n}\n\n.sidebar-content {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.95);\n  overflow-x: auto;\n  overflow-y: auto;\n}\n.sidebar-left .sidebar-content {\n  left: 40px;\n  right: 0;\n  top: 40px;\n}\n.sidebar-right .sidebar-content {\n  left: 0;\n  right: 40px;\n  top: 40px;\n}\n.sidebar.collapsed > .sidebar-content {\n  overflow-y: hidden;\n}\n\n.sidebar-pane {\n  display: none;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n}\n.sidebar-pane.active {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .sidebar-pane {\n    min-width: 259px;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .sidebar-pane {\n    min-width: 344px;\n  }\n}\n@media (min-width: 1200px) {\n  .sidebar-pane {\n    min-width: 399px;\n  }\n}\n\n.sidebar-header {\n  /* margin: -10px -20px 10px; */\n  /* height: 40px; */\n  /* padding: 0 20px; */\n  /* line-height: 40px; */\n  /* font-size: 14.4pt; */\n  /* color: #fff; */\n  /* background-color: rgba(183, 200, 0, 0.9);  */\n}\n.sidebar-right .sidebar-header {\n  /* padding-left: 40px;  */\n}\n\n.sidebar-collapse {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  cursor: pointer;\n}\n.sidebar-left .sidebar-collapse {\n  right: 0px;\n  top: 0px;\n}\n.sidebar-right .sidebar-collapse {\n  left: 0px;\n  top: 0px;\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  right: 0; /* Anchor it to the right edge of the heading */\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n@media (min-width: 768px) {\n  .sidebar {\n    border: 3px solid transparent;\n    border-radius: 4px;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar.hidden {\n    border: 0px;\n  }\n}\n\n.sidebar-left {\n  border-right: 3px solid transparent;\n}\n\n.sidebar-right {\n  border-left: 3px solid transparent;\n}\n\n.sidebar-tabs {\n  overflow: hidden;\n}\n@media (min-width: 768px) {\n  .sidebar-tabs {\n    border-radius: 2px 0 0 2px;\n  }\n  .collapsed .sidebar-tabs {\n    border-radius: 2px;\n  }\n}\n\n@media (min-width: 768px) {\n  .sidebar-content {\n    border-radius: 0 2px 2px 0;\n  }\n}\n\n.ol-viewport {\n  background-color: #fff;\n}\n\n@media (min-width: 768px) {\n  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-zoom,\n  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-zoomslider,\n  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-scale-line,\n  .sidebar-map .sidebar-left.collapsed ~ .ol-viewport .ol-sidebar-sticky {\n    margin-left: 52px;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar-map-control-open {\n    margin-right: 46px;\n  }\n\n  .sidebar-map-control-collapsed {\n    margin-right: 46px;\n  }\n\n  .sidebar-map-control-hidden {\n    margin-right: 0;\n  }\n}\n\n\n@media (min-width: 768px) and (max-width: 991px) {\n   .sidebar-map-control-open {\n    margin-right: 312px;\n  }\n\n  .sidebar-map-control-collapsed {\n    margin-right: 46px;\n  }\n\n  .sidebar-map-control-hidden {\n    margin-right: 0;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n   .sidebar-map-control-open {\n    margin-right: 397px;\n  }\n\n  .sidebar-map-control-collapsed {\n    margin-right: 46px;\n  }\n\n  .sidebar-map-control-hidden {\n    margin-right: 0;\n  }\n}\n@media (min-width: 1200px) {\n   .sidebar-map-control-open {\n    margin-right: 467px;\n  }\n\n  .sidebar-map-control-collapsed {\n    margin-right: 46px;\n  }\n\n  .sidebar-map-control-hidden {\n    margin-right: 0;\n  }\n}\n\n.ol-rotate,\n.ol-base-layer-switcher,\n.ol-coord-zoom-status,\n.ol-status-control {\n  transition: margin-right 500ms, opacity .25s linear, visibility 0s linear !important;\n}\n\n.ol-swipe-tool {\n  position: absolute;\n  bottom: 0;\n  left: 20px;\n  right: 20px;\n}\n\n.swipe-offset-large {\n  bottom: 80px !important;\n}\n\n.swipe-offset-small {\n  bottom: 48px !important;\n}\n\n.ol-overlaycontainer-stopevent {\n  z-index: 5 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
